import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";
import Section8 from "./Section8";
import Section9 from "./Section9";


export default function PerformanceMarketing_Texas() {
  return (
    <div className="Performance-Marketing pt-[160px] sm:pt-0">
      <Helmet>
        <title>Performance Marketing Agency in Texas | Mean3</title>
        <meta
        name="description"
        content=" Mean3 is a Texas-based performance marketing agency delivering measurable results through performance-based campaigns, e-commerce marketing, and advertising strategies."
        />
      </Helmet>
      <Section1 />
      <Section2 />
      <Section3 />
      <Section9 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Section7 />
      <Section8 />
    </div>
  );
}
